import { enableMapSet, setAutoFreeze } from "immer";
import { type CSSProperties, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router";
import { NotificationContainer } from "widgets";

import { initializeClient, type Urls } from "./api/openapi.ts";
import { ErrorFallbackPage } from "./components/fallback/error-fallback-page.tsx";
import { GenomeViewer } from "./GenomeViewer.tsx";
import { FetchError } from "./utils/errors.ts";

const style: CSSProperties = {
  gridArea: "page",
  overflow: "hidden",
  position: "relative",
  outline: "none",
  background: "white",
};

enableMapSet();
setAutoFreeze(false);

interface GenomeViewerPageProps {
  syntenyId?: string;
  urls: Urls;
}

const GenomeViewerPage = ({ syntenyId, urls }: GenomeViewerPageProps) => {
  useEffect(() => {
    initializeClient(urls);
  }, [urls]);
  const navigate = useNavigate();

  return (
    <div style={style} data-testid="genome-viewer">
      <ErrorBoundary
        FallbackComponent={ErrorFallbackPage}
        onError={(error) => {
          if (error instanceof FetchError && error.statusCode === 401) {
            // In case of `401` (`Unauthorized`), we redirect to the login page after a logout.
            navigate("/logout");
          }
        }}
      >
        <GenomeViewer syntenyId={syntenyId} />
      </ErrorBoundary>
      <NotificationContainer />
    </div>
  );
};

export default GenomeViewerPage;
